import { setAgentConnected } from "store/app/app.actions";
import { MiddlewareStore } from "store/createStore";
import { ChatMessageEvent, IChatMessage } from "store/messages/messages.state";

export const handleParticipantJoined = async (message: IChatMessage, store: MiddlewareStore) => {
    if (message.contentType !== ChatMessageEvent.PARTICIPANT_JOINED) return message;

    if (message.role === "CUSTOMER") {
        message.discarded = true;
    }

    if (message.role === "AGENT") {
        store.dispatch(setAgentConnected(true))
    }

    return message;
}